export const LIFE_POLICY = `
query lifePolicy {
  lifePolicy{
    __typename
    ... on LifePolicy{
      coverage
    }
    ... on ResultError{
      status_code
      message
    }
  }
}
`;
